const criteriaByContacts = (a, b) => {
  return b.contacts - a.contacts
}

const criteriaByContactsWithLoss = (a, b) => {
  return b.contactsWithLoss - a.contactsWithLoss
}

const criteriaByLeads = (a, b) => {
  return b.leads - a.leads
}

const criteriaByScreenings = (a, b) => {
  return b.screenings - a.screenings
}

const criteriaByAppointments = (a, b) => {
  return b.appointments - a.appointments
}

const criteriaByAverageContactsPerScreening = (a, b) => {
  return getNumber(b.contacts / b.screenings) - getNumber(a.contacts / a.screenings)
}

const criteriaByAverageContactsWithLossPerScreening = (a, b) => {
  return getNumber(b.contactsWithLoss / b.screenings) - getNumber(a.contactsWithLoss / a.screenings)
}

const criteriaByAverageLeadsPerScreening = (a, b) => {
  return getNumber(b.leads / b.screenings) - getNumber(a.leads / a.screenings)
}

export {
  criteriaByLeads,
  criteriaByContacts,
  criteriaByScreenings,
  criteriaByAppointments,
  criteriaByContactsWithLoss,
  criteriaByAverageLeadsPerScreening,
  criteriaByAverageContactsPerScreening,
  criteriaByAverageContactsWithLossPerScreening,
}

function getNumber (value) {
  if (isNaN(value)) {
    return 0
  }
  return value
}
